"use client";

import * as React from "react";

export type MessageDescriptor = {
  id: string;
  defaultMessage: string;
  description: string;
};

export type MessageValues = Record<string, string | React.ReactNode>;

/**
 * Shape of the i18n context value.
 * This mirrors the essential parts of react-intl's IntlShape without importing it.
 */
export interface IntlContextValue {
  locale: string;
  formatMessage(
    descriptor: MessageDescriptor,
    values?: MessageValues,
  ): string | React.ReactNode[];
}

/**
 * Context for optional i18n support.
 * When this context has a value, translations will use react-intl.
 * When this context is null/undefined, translations will fall back to defaultMessage.
 */
export const IntlContext = React.createContext<IntlContextValue | null>(null);
IntlContext.displayName = "IntlContext";

/**
 * Hook to access the i18n context.
 * Returns null if no IntlProvider is present in the component tree.
 */
export function useIntl(): IntlContextValue | null {
  return React.useContext(IntlContext);
}
